import React, { Component } from "react";

import AppConfig from "Config/AppConfig";
import styles from "./styles.module.scss";

class CircularIcon extends Component {
  state = {
    imageError: false,
  };

  renderDefaultPic = () => {
    const { defaultIcon } = this.props;
    let DefaultIcon;
    if (defaultIcon) {
      DefaultIcon = defaultIcon;
    } else {
      DefaultIcon = AppConfig.NoProfilePic;
    }
    return <DefaultIcon className={styles.icon} />;
  };

  render() {
    const { icon, text, onClick } = this.props;
    const { imageError } = this.state;
    return (
      <div className={styles.container} onClick={onClick}>
        <div className={styles.iconContainer}>
          {imageError || !icon ? (
            this.renderDefaultPic()
          ) : (
            <img
              src={icon}
              alt="Not Found"
              onError={() => this.setState({ imageError: true })}
              className={styles.icon}
            />
          )}
        </div>
        {text && <div className={styles.iconText}>{text}</div>}
      </div>
    );
  }
}

export default CircularIcon;
